import axios from "axios";
import store from "@/store";

// Traza de auditoría de los filtros aplicados en el visor
// (api/v1/layer-activity/filter). Módulo plano, no mixin: lo consume
// AttributesTable.vue igual que savedFiltersApi.js. `axios` importado directo
// ya trae withCredentials:true (main.js lo setea global sobre la misma
// instancia que Vue.prototype.$http).
export const filterActivityApi = {
  // Fallo silencioso a propósito: la auditoría nunca debe romper ni demorar la
  // aplicación del filtro (mismo criterio que restLayerActivity.js).
  record({ layerId, layerName, mapId, mode, filter }) {
    if (!layerId) return Promise.resolve();
    return axios
      .post(`${store.getters.backendurl}api/v1/layer-activity/filter`, {
        layer_id: layerId,
        layer_name: layerName || "",
        map_id: mapId || "",
        mode,
        filter,
      })
      .catch(error => { console.log("layer-activity filter:", error); });
  },
};
